import actions from "../constants/hubReconciliationActions";

export const getHubReconciliationList = (data) => ({
  type: actions.GET_HUB_RECONCILIATION_LIST,
  data,
});

export const startHubReconciliation = (data) => ({
  type: actions.START_HUB_RECONCILIATION,
  data,
});

export const scanBarcode = (data) => ({
  type: actions.SCAN_BARCODE,
  data,
});

export const closeHubReconciliation = (data) => ({
  type: actions.CLOSE_HUB_RECONCILIATION,
  data,
});

export const getReportData = (data) => ({
  type: actions.GET_REPORT_DATA,
  data,
});

export const clearStartHubReconciliation = () => ({
  type: actions.START_HUB_RECONCILIATION_CLEAR,
});
